import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ITCReconciliation, ITCReconciliationCreate, ITCReconciliationFilter } from '../data/iTCReconciliation';

export function createITCReconciliationService(client: AxiosInstance) {
  return createCrudService<ITCReconciliation, ITCReconciliationCreate, ITCReconciliationFilter>(
    client,
    '/accounting/ITCReconciliation',
    'id',
  );
}

export type ITCReconciliationService = CrudService<ITCReconciliation, ITCReconciliationCreate, ITCReconciliationFilter>;
